import React from 'react';
import { clsx } from '../utils/utils';
import * as styles from './Panel.module.scss';

export interface PanelProps {
  className?: string;
  infoSysPortal?: boolean;
  onClick?: () => void;
  children: React.ReactNode;
}

const Panel = ({ className, infoSysPortal, onClick, children }: PanelProps): React.ReactElement => {
  return (
    <div className={clsx(styles.container, className)} onClick={onClick}>
      <div
        className={clsx(styles.backgroundContainer, infoSysPortal && styles.infoSysPortal)}
      ></div>
      {children}
    </div>
  );
};

export default Panel;
